const authConfig = {
  authority: 'https://bettertrucks-dev-hnhkdb.us1.zitadel.cloud',
  client_id: '305796202002215122',
  response_type: 'code',
  scope: 'openid profile email',
  userinfo_endpoint: 'https://bettertrucks-dev-hnhkdb.us1.zitadel.cloud/oidc/v1/userinfo',
  response_mode: 'query',
  code_challenge_method: 'S256',
};

export default authConfig;
